import { createDownloadSlice } from '@repo/core'
import { CommunicationDocumentParams } from '@repo/mailbox-types'

export const {
  actions: communicationDocumentDownloadActions,
  reducer: communicationDocumentDownloadReducer,
} = createDownloadSlice<CommunicationDocumentParams>('@mailbox/communications/documentDownload')
